import PropTypes from "prop-types";
import React from "react";

export const legacyDataLayerInitPayloadIndex = 0;

export default class DataLayer extends React.Component {
  static get data() {
    const { dataLayer } = window.lp.analytics;
    dataLayer[legacyDataLayerInitPayloadIndex] = dataLayer[legacyDataLayerInitPayloadIndex] || {};
    return dataLayer[legacyDataLayerInitPayloadIndex];
  }

  static propTypes = {
    data: PropTypes.objectOf(Object),
  };

  componentDidMount() {
    Object.assign(DataLayer.data, this.props.data);
  }

  componentWillReceiveProps(nextProps) {
    Object.assign(DataLayer.data, nextProps.data);
  }

  render() {
    return (
      <div className="DataLayer" />
    );
  }
}



// WEBPACK FOOTER //
// ./assets/shared/components/dataLayer.jsx